/** The schema lookup refuses a site with no project type with this sentence. */
export function isMissingProjectType(message: string | undefined): boolean {
  return /no project type/i.test(message ?? '');
}
